export default __webpack_public_path__ + "static/media/delievers8.8d764b24.png";